$shm_hitalama_map_widget_float_chrome_telegram $shm_hitalama_map_widget_float_form_custom
	chat_id? \
	chat_title? \
	auto /
		^
		<= rpc_listener null
		<= require_id null
	Content_by_type_override* *any
		any
			<= Textarea*
		string
			<= Textarea* $mol_textarea
				value? <=> field_value*?
		textarea
			<= Textarea*
		date
			<= Date*
		period
			<= Period*
		file
			<= File*
		file_pb
			<= File_pb*
	Details_icon $mol_icon_dots_horizontal
